import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import { ImageCropper } from '../../../Utils/Constants'
import ImageCropperBody from './ImageCropperBody'
import CardHeaderCommon from '../../../Utils/CommonComponents/CardHeaderCommon'

const ImageCropperContainer = () => {
  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardHeaderCommon title={ImageCropper} span={[{text:"Use The Image Cropper.ts"}]} />
            <CardBody>
              <ImageCropperBody />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default ImageCropperContainer